import { useContext } from 'react'
import { DevXContext } from 'contexts/devXContext'

export const useDevXContext = () => {
  return useContext(DevXContext)
}
